import * as React from 'react';
import HeaderWrapper from '~/common/elements/mobile/HeaderWrapper';
import HeaderLayoutLeft from '~/common/elements/mobile/HeaderLayoutLeft';
import HeaderLayoutCenter from '~/common/elements/mobile/HeaderLayoutCenter';
import HeaderLayoutRight from '~/common/elements/mobile/HeaderLayoutRight';
import { icons } from '~/common/elements/mobile/consts';
import HeaderButton from '~/common/elements/mobile/HeaderButton';


export default function SaleHeader(props) {
  const { title, onBack, onHelp, isMain, iconLeft, customStyleTitle, onClose } = props;

  const handleButtonActions = (actionKey, e) => {
    e.preventDefault();

    switch (actionKey) {
      case 'on-click-left':
        if (onBack) onBack(actionKey, e);
        break;

      case 'on-click-right':
        if (onHelp) onHelp(actionKey, e);
        break;

      case 'on-click-close':
        if (onClose) onClose(actionKey, e);
        break;

      default:
        console.log(`Not action in SaleHeader: ${actionKey}`);
        break;
    }
  };

  return (
    <HeaderWrapper>
      <HeaderLayoutLeft>

        {!isMain ? (onBack && (<HeaderButton
            onClick={handleButtonActions}
            iconType={!iconLeft ? icons.ARROW_LEFT : iconLeft}
            actionKey="on-click-left"
          />)) :
          <a href="javascript:void(null)" className="m__head__logo">
            <span className="i i-logo" />
          </a>
        }

      </HeaderLayoutLeft>
      <HeaderLayoutCenter>
        <a href="javascript:void(null)"
           className="m__head__logo dn"
        >
          <span className="i i-logo" />
        </a>
        {onHelp && onClose &&
          <HeaderButton
            onClick={handleButtonActions}
            iconType={icons.HELP}
            actionKey="on-click-right"
          />
        }
        <span
          className="m__head__titl"
          style={customStyleTitle}
        >
          {title}
        </span>
      </HeaderLayoutCenter>
      <HeaderLayoutRight>
        {onHelp && !onClose &&
          <HeaderButton
            onClick={handleButtonActions}
            iconType={icons.HELP}
            actionKey="on-click-right"
          />
        }
        {onClose &&
          <HeaderButton
            onClick={handleButtonActions}
            iconType={icons.CLOSE}
            actionKey="on-click-close"
          />
        }
      </HeaderLayoutRight>
    </HeaderWrapper>
  );
};
